module.exports = __webpack_public_path__ + "static/media/door_left_front.5db4708f.jpg";